<template>
  <div class="animated fadeIn">
    <div v-if="!user.id">
      <p>User not found, or you do not have access to this user in the given Org/Group context.</p>
    </div>
    <div v-if="user.id" class='personPage'>
      <b-row class="mb-3" align-h="between">
        <b-col cols="auto">
          <h4 class="card-title mb-0">{{ user.fullName }}</h4>
          <div class="small text-muted">Added {{ getCreatedAt() }}</div>
        </b-col>
        <b-col cols="auto">
          <router-link :to="'/admin/users/' + user.id + '/edit'">
            <b-button class="mx-0">Edit</b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div>
            <b-card no-body>
              <b-card-header>
                <strong>Information</strong>
                <label class="switch switch-lg switch-text switch-pill switch-primary-outline-alt pull-right mb-0 wide-toggle">
                  <input
                    id="positive_switch"
                    @change="toggleIsCseitTrained"
                    type="checkbox"
                    class="switch-input"
                    :checked="user.isCseitTrained"
                  >
                  <span class="switch-label" data-on="CSE-IT Trained" data-off="Not CSE-IT Trained"></span>
                  <span class="switch-handle"></span>
                </label>
              </b-card-header>
              <b-card-body>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">ID</small>
                  <br>
                  <h4>{{ user.id }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Name</small>
                  <br>
                  <h4>{{ user.fullName }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Email</small>
                  <br>
                  <h4>{{ user.emailAddress }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Primary Organization</small>
                  <br>
                  <h4>{{ user.primaryOrganization.title }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Accepted End User Agreement</small>
                  <br>
                  <h4>{{ user.acceptedEUA > 0 ? 'true' : 'false' }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Active</small>
                  <br>
                  <h4>{{ user.isRemoved ? 'Deactivated' : user.active }}</h4>
                </div>
                <div class="pb-4">
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Super Administrator</small>
                  <br>
                  <h4>{{ user.isSuperAdmin }}</h4>
                </div>
                <div>
                  <small class="mb-0 text-muted text-uppercase font-weight-bold">Welcome Email Sent:</small>
                  <br>
                  <h4 v-if="user.lastWelcomeEmail">
                    {{ getWelcomeDate() }}
                  </h4>
                </div>
                 <br>
                <br>
                 <b-row>
                   <b-col>
                    <b-button  type="submit" variant="primary" v-on:click.prevent="sendWelcomeEmail">Send Welcome Email</b-button>
                    <br> <br>
                    <b-button  type="submit" variant="primary" v-on:click.prevent="sendPasswordResetEmail">Send Password Reset Email</b-button>
                   </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h2 v-show="emailSentInProcess" class="u-padding-bottom-20">Sending Email, please wait ...</h2>
                        <pulse-loader :loading="emailSentInProcess" color="#0F347B" size="50px"></pulse-loader>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <br>
                    <b-alert
                      fade
                      :show="(this.emailSentFailure ||this.emailSentSuccess)"
                      :variant="emailSentFailure  ? 'danger' : 'success'">
                      <span v-html="apiResponseMessage()"></span>
                    </b-alert>
                  </b-col>
                </b-row>
                </b-card-body>
            </b-card>
          </div>
        </b-col>
        <b-col sm="4">
        <b-row v-if="!user.active || user.isRemoved">
            <b-col sm="12">
              <b-card bg-variant='danger'>
                <div> {{ user.isRemoved ? `This user is deactivated` :
                  `This user is inactive`}}
                </div>

              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12">
              <UserMemberships :user="user" :userId="userId"></UserMemberships>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-card no-body>
                <b-card-header>
                  <b>Meta</b>
                </b-card-header>

                <b-list-group flush>
                  <b-list-group-item class="small text-muted">
                    <b>Created At: </b> {{ getCreatedAt() }}
                    <div v-if="_.isObject(user.createdBy)">
                      <b> by: </b> {{ _.get(user, 'createdBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>

                  <b-list-group-item class="small text-muted">
                    <b>Last Updated: </b> {{ getLastUpdateDate() }}
                    <div v-if="_.isObject(user.updatedBy)">
                      <b> by: </b> {{ _.get(user, 'updatedBy.emailAddress', '') }}
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import UserMemberships from '@/components/Admin/UserMemberships'

  export default {
    name: 'user',
    components: {
      UserMemberships
    },
    computed: {
      ...mapGetters({
        user: 'getViewUser',
        userCurrentContext: 'userCurrentContext',
        emailSentSuccess: 'getEmailSentSuccess',
        emailSentFailure: 'getEmailSentFailure',
        emailSentInProcess: 'getEmailSentInProcess',
        updateUserSuccess: 'updateUserSuccess'
      }),
      userId: function () {
        return parseInt(this.$route.params.id, 10)
      }
    },
    methods: {
      getCreatedAt () {
        const user = this.user
        if (user.createdAt && user.createdAt.includes('T')) {
            return this.$utils.formatDate(user.createdAt)
        } else if (user.createdAt) {
            return this.$utils.unixToHuman(user.createdAt / 1000)
        } else {
          return 'Unknown'
        }
      },
      getLastUpdateDate () {
        const user = this.user
        if (user.updatedAt && user.updatedAt.includes('T')) {
            return this.$utils.formatDate(user.updatedAt)
        } else if (user.updatedAt) {
            return this.$utils.unixToHuman(user.updatedAt / 1000)
        }
      },
      getWelcomeDate () {
        const user = this.user
        if (user.lastWelcomeEmail && user.lastWelcomeEmail.includes('T')) {
            return this.$utils.formatDate(user.lastWelcomeEmail)
        } else if (user.lastWelcomeEmail) {
            return this.$utils.unixToHuman(user.lastWelcomeEmail / 1000)
        }
      },
      sendWelcomeEmail: function () {
        var url
        if (process.env.NODE_ENV === 'production') {
          url = 'lighthouse'
        } else {
          url = 'dev.lighthouse'
        }
        var formDate = { email: this.user.emailAddress, name: this.user.fullName, environment: url }
        this.$store.dispatch('sendWelcomeEmail', formDate)
      },
      apiResponseMessage: function () {
        let message = ''
        if (this.emailSentSuccess) {
          message = this.emailSentSuccess
          return '<p>' + message + '</p>'
        }
        if (this.emailSentFailure) {
          message = this.emailSentFailure
          return '<p>' + message + '</p>'
        }
      },
      sendPasswordResetEmail: function () {
        var email = this.user.emailAddress
        this.$store.dispatch('sendPasswordResetEmail', { email: email })
      },
      maybeFormatDate: function (field) {
        let value = this.user[field]
        if (field === 'createdAt' || field === 'updatedAt') {
          return this.$utils.unixToHuman(value / 1000)
        } else if (field === 'primaryOrganization') {
          return value.title
        } else if (field === 'memberOrganizations') {
          return value.map(v => v.title).join(', ')
        }
        return value
      },
      getFields: function (user) {
        let fields = this._.filter(Object.keys(user), function (field) {
          let fieldValue = user[field]
          if (!_.identity(fieldValue)) {
            return false
          }

          return true
        })
        return fields
      },
      organizationMailingAddress: function () {
        return (
          this.person.organization.mailingStreet +
          ' ' +
          this.person.organization.mailingCity +
          ', ' +
          this.person.organization.mailingStateAbbreviation +
          ' ' +
          this.person.organization.mailingPostalCode
        )
      },
      populateRecords: function () {
        this.$store.dispatch('getUser', {
          id: this.userId
        })
      },
      resetEmail () {
        this.$store.commit('resetEmailUserView')
      },
      resetAll () {
        this.$store.commit('resetViewUser')
        this.resetEmail()
      },
      toggleIsCseitTrained () {
        this.$store.dispatch('updateUser', {
          id: this.userId,
          data: {
            isCseitTrained: !this.user.isCseitTrained
          }
        })
      }
    },
    data: function () {
      return {
        timestamp: ''
      }
    },
    watch: {
      emailSentSuccess: function (newValue) {
        _.delay(this.resetEmail, 1000)
      },
      userCurrentContext: function (newValue) {
        if (newValue) {
          this.populateRecords()
        }
      },
      userIsCseItTrained (newValue) {
        console.log('userIsCseItTrained', newValue)
      }
    },
    beforeDestroy: function () {
      this.resetAll()
    },
    created: function () {
      this.populateRecords()
    }
  }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px) {
  .card-header .btn-sm .plus {
    display: none;
  }
}

@media screen and (max-width: 1100px) {
  .card-header .btn-sm {
    line-height: 16px;
  }

  .card-header .btn-sm .button-text {
    display: none;
  }

  .card-header .btn-sm .plus {
    display: inline;
  }
}

.switch.switch-text.switch-lg.wide-toggle {
  width: 180px;

  .switch-input:checked ~ .switch-handle {
    left: 154px; // 180px - 24px (pill size) - 2px (offset)
  }

  .switch-label {
    &::after,
    &::before {
      width: 156px; // 180px - 24px (pill size)
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/t1/Admin/User.vue